/*
 *
 * ModeBar actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { ConfiguratorMode, HandlesMode } from './reducer';
import { CustomPiece } from '../../lib/modelBuilder/pieces/CustomPiece';
import { ComponentKewlox } from '../../lib/modelBuilder/pieces/ComponentKewlox';
import TabNames from '../Header/TabNames';

export const switchModeAction = (
  mode: ConfiguratorMode,
  lastTabName?: TabNames,
) => action(ActionTypes.SWITCH_MODE, { mode, lastTabName });

export const switchHandlesModeAction = (handlesMode: HandlesMode) =>
  action(ActionTypes.SWITCH_HANDLE_MODE, { handlesMode });

export const applyDeleteAction = (
  customPiece: CustomPiece<ComponentKewlox>,
  cabinetId: string,
  shelfLevel?: number,
  rackLevel?: number,
  interShelfLevel?: number,
) =>
  action(ActionTypes.APPLY_DELETE, {
    customPiece,
    cabinetId,
    shelfLevel,
    rackLevel,
    interShelfLevel,
  });

export const applyColorHandleAction = (
  customPiece: CustomPiece<ComponentKewlox>,
  cabinetId: string,
  shelfLevel?: number,
  rackLevel?: number,
  interShelfLevel?: number,
) =>
  action(ActionTypes.APPLY_COLOR_HANDLE, {
    customPiece,
    cabinetId,
    shelfLevel,
    rackLevel,
    interShelfLevel,
  });
